import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ErrorComponent from '../../common/components/ErrorComponent';
import {
  accident_statuses,
  after_sale_purchase_statues,
} from '../../common/constants';
import { listAfterSales, resetListAfterSales } from '../../features/afterSale/afterSaleActions';
import {
  PageStyles,
  PageHeader,
  AfterSaleCard,
  CardContent,
  CustomerName,
  InfoChip,
  DateInfo,
  CardActions,
  StatusBadge,
  ActionButton,
  LoadingState,
  EmptyState,
} from './AfterSalesList.styles';

function AfterSalesList() {
  const state = useSelector((store) => store.afterSale.after_sales);

  const {
    loading, after_sales, error,
  } = state;

  // const [search, setSearch] = useState({
  //   search: '',
  //   date_from: moment().startOf('month').format('YYYY-MM-DD'),
  //   date_to: moment().format('YYYY-MM-DD'),
  //   quotation_status: 'all',
  // });

  const getAfterSalesType = (type) => {
    if (type === 'accident') return 'Sinistro';
    if (type === 'replacement') return 'Sostituzione';
    if (type === 'cancellation') return 'Cessazione';
    if (type === 'modification') return 'Modifica';
    if (type === 'suspension') return 'Sospensione';
    return '';
  };

  useEffect(() => {
    listAfterSales();
    return () => {
      resetListAfterSales();
    };
  }, []);

  const getItemLink = (item) => `/after-sale/purchase/${item.after_sale_type}/${item.id}`;

  return error === null ? (
    <PageStyles>
      <div className="container-fluid">
        <PageHeader>
          <h2>🔧 Post Vendita Attive</h2>
        </PageHeader>

        <div className="row">
          <div className="col-12">
            {loading ? (
              <LoadingState>
                <div className="spinner-border" role="status" />
                <span>Attendere prego...</span>
              </LoadingState>
            ) : after_sales.length > 0 ? (
              after_sales.map((item, index) => (
                <AfterSaleCard key={index}>
                  <CardContent>
                    {item.quotation.active_customer && (
                      <CustomerName>
                        👤 Cliente:
                        {' '}
                        {item.quotation.active_customer.gender === 'G'
                          ? item.quotation.active_customer.business_name
                          : `${item.quotation.active_customer.name} ${item.quotation.active_customer.surname}`}
                      </CustomerName>
                    )}
                    {item.quotation.insurance_request.customer && (
                      <CustomerName>
                        👤 Cliente:
                        {' '}
                        {item.quotation.insurance_request.customer.gender !== 'G'
                          ? `${item.quotation.insurance_request.customer.name} ${item.quotation.insurance_request.customer.surname}`
                          : item.quotation.insurance_request.customer.business_name}
                      </CustomerName>
                    )}
                    {item.quotation.insurance_request.product && (
                      <InfoChip>
                        <span className="icon">📋</span>
                        <strong>Prodotto:</strong>
                        {' '}
                        {item.quotation.insurance_request.product.name}
                      </InfoChip>
                    )}
                    <InfoChip>
                      <span className="icon">🏷️</span>
                      <strong>Tipo:</strong>
                      {' '}
                      {getAfterSalesType(item.after_sale_type)}
                    </InfoChip>
                    {item.quotation.insurance_request
                      && item.quotation.insurance_request.vehicle !== null && (
                      <InfoChip>
                        <span className="icon">🚗</span>
                        <strong>Targa:</strong>
                        {' '}
                        {item.quotation.insurance_request.vehicle.vehicle_plate}
                      </InfoChip>
                    )}
                    {item.quotation.insurance_request && item.quotation.insurance_request.moto && (
                      <InfoChip>
                        <span className="icon">🏍️</span>
                        <strong>Targa:</strong>
                        {' '}
                        {item.quotation.insurance_request.moto.moto_plate}
                      </InfoChip>
                    )}
                    <DateInfo>
                      <strong>
                        Creato:
                        {' '}
                        {new Date(item.created_at).toLocaleDateString('it-IT', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </strong>
                    </DateInfo>
                  </CardContent>
                  <CardActions>
                    <StatusBadge>
                      {item.after_sale_type === 'accident'
                        ? accident_statuses.find((f) => (item.status_id ? f.id === item.status_id : f.id === item.status)).name
                        : after_sale_purchase_statues.find((f) => (item.status_id ? f.id === item.status_id : f.id === item.status)).name}
                    </StatusBadge>
                    <ActionButton to={getItemLink(item)}>
                      Vai a
                      {' '}
                      {getAfterSalesType(item.after_sale_type)}
                    </ActionButton>
                  </CardActions>
                </AfterSaleCard>
              ))
            ) : (
              <EmptyState>
                <div className="fw-bold">Nessuna richiesta trovata!</div>
              </EmptyState>
            )}
          </div>
        </div>
      </div>
    </PageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default AfterSalesList;
